<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card class="card" color="primary">
          <v-card-title>
            <div class="text-h6">Lista de equipos</div>
            <v-spacer></v-spacer>
            <v-text-field
              label="Buscar"
              v-model="searchEquipo"
              append-icon="mdi-magnify"
              rounded
              filled
              dense
              color="secondary"
              background-color="primary"
            ></v-text-field>
          </v-card-title>
          <v-card-text>
            <v-data-table :headers="headers" :items="equipos" class="transparent" :search="searchEquipo">
              <template v-slot:[`item.opciones`]="{ item }">
                <v-btn icon class="mr-1" color="secondary" @click="openUpdateEquipoDialog(item)"
                  ><v-icon>mdi-pencil</v-icon></v-btn
                >
                <v-btn icon color="secondary" @click="openUpdateEstatusEquipoDialog(item)"
                  ><v-icon>mdi-update</v-icon></v-btn
                >
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <update-equipo-dialog-component
      :active="updateEquipoDialog"
      @close="updateEquipoDialog = false"
      :equipo="selectedEquipo"
    ></update-equipo-dialog-component>
    <estatus-equipo-dialog-component
      :active="updateEstatusEquipoDialog"
      @close="updateEstatusEquipoDialog = false"
      :equipo="selectedEquipo"
    ></estatus-equipo-dialog-component>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import EstatusEquipoDialogComponent from '../../components/equipamiento/EstatusEquipoDialogComponent.vue'
import UpdateEquipoDialogComponent from '../../components/equipamiento/UpdateEquipoDialogComponent.vue'

export default {
  components: {
    UpdateEquipoDialogComponent,
    EstatusEquipoDialogComponent,
  },

  data() {
    return {
      headers: [
        { text: 'Categoría', value: 'CatItem.CatTipoItem.title' },
        { text: 'Item', value: 'CatItem.item' },
        { text: 'Número', value: 'numero' },
        { text: 'Fecha de fabricación', value: 'fechaFabricacion' },
        { text: 'Vigencia', value: 'aniosVigencia' },
        { text: 'Estatus', value: 'CatEstatus.title' },
        { text: 'Opciones', value: 'opciones' },
      ],

      updateEquipoDialog: false,
      updateEstatusEquipoDialog: false,

      selectedEquipo: null,

      searchEquipo: '',
    }
  },

  computed: {
    ...mapGetters('equipo', {
      equipos: 'getEquipos',
    }),
  },

  methods: {
    openUpdateEquipoDialog(equipo) {
      this.selectedEquipo = equipo
      this.updateEquipoDialog = true
    },

    openUpdateEstatusEquipoDialog(equipo) {
      this.selectedEquipo = equipo
      this.updateEstatusEquipoDialog = true
    },
  },
}
</script>

<style scoped>
/* Estilos modernos para Equipo de Equipamiento */
.card {
  background: rgba(46, 36, 22, 0.6) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 159, 67, 0.2);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  animation: fadeInUp 0.6s ease-out;
}

/* Títulos */
::v-deep .v-card-title {
  color: #e0e0e0 !important;
  font-weight: 700 !important;
  letter-spacing: 0.5px;
  padding: 24px !important;
}

.text-h6 {
  color: #ffbe76 !important;
  font-weight: 700;
}

/* Input de búsqueda */
::v-deep .v-text-field .v-input__slot {
  background: transparent !important;
  border: 1px solid rgba(255, 159, 67, 0.2) !important;
  border-radius: 12px !important;
  transition: all 0.3s ease !important;
}

::v-deep .v-text-field .v-input__slot:hover {
  border-color: rgba(255, 159, 67, 0.3) !important;
}

::v-deep .v-input--is-focused .v-input__slot {
  border-color: #ff9f43 !important;
  box-shadow: none !important;
  background: transparent !important;
}

::v-deep .v-text-field__slot input {
  color: #e0e0e0 !important;
}

::v-deep .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
  font-weight: 500;
}

::v-deep .v-input--is-focused .v-label {
  color: #ffbe76 !important;
  font-weight: 600;
}

::v-deep .v-input__append-inner .v-icon {
  color: rgba(255, 159, 67, 0.6) !important;
}

::v-deep .v-input--is-focused .v-input__append-inner .v-icon {
  color: #ff9f43 !important;
}

/* Tabla */
::v-deep .v-data-table {
  background: transparent !important;
  color: #e0e0e0 !important;
}

::v-deep .v-data-table-header {
  background: linear-gradient(180deg, rgba(255, 159, 67, 0.15) 0%, rgba(255, 159, 67, 0.08) 100%) !important;
}

::v-deep .v-data-table-header th {
  color: #e0e0e0 !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 1px;
  border-bottom: 2px solid rgba(255, 159, 67, 0.3) !important;
  padding: 16px !important;
}

::v-deep .v-data-table tbody tr {
  transition: all 0.3s ease;
  cursor: pointer;
}

::v-deep .v-data-table tbody tr:hover {
  background: rgba(255, 159, 67, 0.1) !important;
  transform: scale(1.005);
  box-shadow: 0 2px 8px rgba(255, 159, 67, 0.2);
}

::v-deep .v-data-table tbody td {
  color: #e0e0e0 !important;
  border-bottom: 1px solid rgba(255, 159, 67, 0.08) !important;
  padding: 16px !important;
}

/* Botones de iconos */
::v-deep .v-btn {
  border-radius: 12px !important;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  position: relative;
  overflow: hidden;
}

::v-deep .v-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
  pointer-events: none;
}

::v-deep .v-btn:active::before {
  width: 300px;
  height: 300px;
}

::v-deep .v-btn:hover {
  transform: translateY(-2px) scale(1.1);
  box-shadow: 0 6px 20px rgba(255, 159, 67, 0.4) !important;
}

::v-deep .v-btn.v-btn--icon {
  background: rgba(255, 159, 67, 0.1);
  border: 1px solid rgba(255, 159, 67, 0.2);
}

::v-deep .v-btn.v-btn--icon:hover {
  background: rgba(255, 159, 67, 0.2);
  border-color: #ff9f43;
}

::v-deep .v-icon {
  color: #ffbe76 !important;
  transition: all 0.3s ease;
}

::v-deep .v-btn:hover .v-icon {
  color: #ff9f43 !important;
  transform: scale(1.2);
}

/* Data Footer */
::v-deep .v-data-footer {
  background: rgba(46, 36, 22, 0.4) !important;
  border-top: 1px solid rgba(255, 159, 67, 0.2) !important;
  color: #e0e0e0 !important;
}

::v-deep .v-data-footer__select .v-select {
  color: #e0e0e0 !important;
}

::v-deep .v-data-footer__select .v-select__selection {
  color: #e0e0e0 !important;
}

::v-deep .v-data-footer .v-icon {
  color: rgba(255, 159, 67, 0.6) !important;
}

::v-deep .v-data-footer .v-btn:hover .v-icon {
  color: #ff9f43 !important;
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(255, 159, 67, 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 159, 67, 0.6);
}

/* Animación */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
